// eslint-disable-next-line import/no-cycle
import {
  TemplateStructureEnum,
  ElementPartTypeEnum,
  TemplateParentTypeEnum,
} from '@/types';

const headerButtonsAvailable: Record<string, string[]> = {
  [TemplateStructureEnum.DESIGN]: ['informationPanel', 'designPanel', 'advancedCssPanel'],
  [TemplateStructureEnum.SECTION]: [
    'informationPanel',
    'configurationPanel',
    'widgetsPanel',
    'loadElementsPanel',
    'translationPanel',
  ],
  [TemplateStructureEnum.WIDGET]: ['informationPanel', 'configurationPanel', 'translationPanel'],
};

const defaultPanel: Record<string, string> = {
  [TemplateStructureEnum.DESIGN]: 'designPanel',
  [TemplateStructureEnum.SECTION]: 'configurationPanel',
  [TemplateStructureEnum.WIDGET]: 'configurationPanel',
};

const elementPartTypeHeaderButtonsAvailable: Record<string, string[]> = {
  [ElementPartTypeEnum.STYLES]: ['informationPanel', 'configurationPanel'],
};

interface StyleProperty {
  name: string;
  type: string;
  operator?: string;
}

interface StyleConfig {
  selector: string;
  defaultReplaceSelectorId: string;
  properties: StyleProperty[];
}

interface TemplateStylesConfig {
  [key: string]: StyleConfig;
}

export type AdditionalStylesConfig = {
  [K in TemplateParentTypeEnum]?: TemplateStylesConfig;
};

export const additionalStylesConfig: AdditionalStylesConfig = {
  [TemplateParentTypeEnum.EMAIL]: {
    spm_call_to_action: {
      selector: '{ID} table.button',
      defaultReplaceSelectorId: '[id^="spm_widget"]',
      properties: [
        {
          name: 'align',
          type: 'attribute',
        },
        {
          name: 'spm_display_fullwidth_mobile',
          type: 'class',
        },
      ],
    },
    spm_widget_image: {
      selector: '{ID} th img',
      defaultReplaceSelectorId: '[id^="spm_widget"]',
      properties: [
        {
          name: 'spm_display_fullwidth_mobile',
          type: 'class',
        },
      ],
    }
  },
  [TemplateParentTypeEnum.EMBED]: {
    spm_display_call_to_action: {
      selector: '{ID} a.spm_button',
      defaultReplaceSelectorId: '[id^="spm_widget"]',
      properties: [
        {
          name: 'spm_div_align_',
          type: 'class',
          operator: 'hasValue',
        },
      ],
    },
  },
  [TemplateParentTypeEnum.POPUP]: {
    spm_display_call_to_action: {
      selector: '{ID} a.spm_button',
      defaultReplaceSelectorId: '[id^="spm_widget"]',
      properties: [
        {
          name: 'spm_div_align_',
          type: 'class',
          operator: 'hasValue',
        },
      ],
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export const isPanelVisible = (syncElementType: string, panel: string, elementPartType?: ElementPartTypeEnum) => {
  let headerButton = headerButtonsAvailable[syncElementType];
  if (elementPartType) {
    headerButton = elementPartTypeHeaderButtonsAvailable[elementPartType];
  }
  if (!headerButton) return false;

  return !!headerButton.find((button) => button === panel);
};

export const getDefaultPanel = (syncElementType: string) => defaultPanel[syncElementType] || 'informationPanel';
